export enum ROLES {
  DISROOPTIVE = 'disrooptive',
  ADMIN = 'admin',
  USER = 'user',
  VIEWER = 'viewer'
}

export default ROLES;
